// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"Content--keyboard_navigation_jump--1V9tm","content_section":"Content--content_section--33JQD","hide_for_print":"Content--hide_for_print--3e5Q3"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/Content/Content.css
// module id = 1017
// module chunks = 0